import React, { useEffect } from 'react';
import { compose, pick } from 'ramda';

import Slider from '@core/js/components/common/Slider';

import { Slide } from '@interlayer/js/components/main/Banner/components/Slide/Slide';

import { withComponent } from '@core/js/components/hocs/withComponent';
import * as hooks from '@core/js/components/main/Banner/hooks';
import { useDynamicReducerDispatch, useDynamicReducerSelector, withDynamicReducer } from '@core/js/components/main/Banner/store';
import * as actions from '@core/js/components/main/Banner/store/actions';
import { useComponentConfig, useComponentMethods, useComponentTranslations } from '@core/js/hooks/component';
import { useIsMounted } from '@core/js/hooks/useIsMounted';

import { useGetBannerDataAttr } from './sun/hooks/useGetBannerDataAttr';

import style from '@core/js/components/main/Banner/Banner.scss';

/* Sun: added dataAttr */
export const BannerBare: React.FC = () => {
    const isMounted = useIsMounted();
    const getSlides = hooks.useGetSlides();
    const translate = useComponentTranslations();
    const { bannerFeedName } = useComponentConfig();
    const { showComponentError } = useComponentMethods();
    const dynamicReducerDispatch = useDynamicReducerDispatch();
    const { slides, sliderOptions } = useDynamicReducerSelector(pick(['slides', 'sliderOptions']));

    useEffect(() => {
        if (!bannerFeedName) {
            showComponentError(translate('empty'));
        }
    }, [bannerFeedName, translate, showComponentError]);

    useEffect(() => {
        if (!bannerFeedName) {
            return;
        }

        getSlides()
            .then((response) => {
                isMounted() && dynamicReducerDispatch(actions.setSlidesAndOptions(response));
            })
            .catch((response) => {
                isMounted() && dynamicReducerDispatch(actions.setSlidesAndOptions(response));
            });
    }, [getSlides, dynamicReducerDispatch, isMounted, bannerFeedName]);

    const getBannerDataAttr = useGetBannerDataAttr();

    if (!slides || !slides.length) {
        return null;
    }

    return (
        <div className={`${style.banner} cms-banner`}>
            <Slider options={sliderOptions}
                classNames={{
                    slider: style.slider,
                    bullets: style.bullets,
                    leftArrow: style.leftArrow,
                    rightArrow: style.rightArrow,
                    sliderContainer: style.sliderContainer
                }}
                autoRotate={true}
            >
                {slides.map((slide, index) => <Slide key={slide.id} slide={slide} dataAttr={getBannerDataAttr(index)} />)}
            </Slider>
        </div>
    );
};

export const Banner = compose(
    withComponent({ tkPrefix: 'playtech.mobile.system.banner.' }),
    withDynamicReducer()
)(BannerBare);

export default Banner;
